<template>
  <div class="material-property">
    <SetPopup ref="confirm" />

    <v-form ref="materialProperty" lazy-validation @submit.prevent="search">
      <div class="filter-box filter-box--row">
        <ul class="filter-list_free">
          <li style="width: 200px; min-width: 200px;">
            <h4>원료</h4>
            <v-text-field outlined dense placeholder="" v-model="param.material" @keyup.enter="search"></v-text-field>
          </li>
        </ul>
        <div class="btn-box">
          <v-card-actions>
            <v-btn depressed class="btn-reset" @click="reset">초기화</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn depressed class="btn-search" @click="search">검색</v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-form>

    <h3 class="mt-2 mb-2 dp--row">
      <v-btn style="margin-left: auto" depressed class="btn-add" @click="openAddTab">등록</v-btn>
    </h3>

    <RealGrid :domName="grid" ref="grid" :settings="settings" @changePage="search" @dbClick="openEditTab" />
  </div>
</template>

<script>
import { columns, fields } from '@/assets/grid/materialProperty';
import RealGrid from '@/components/RealGrid.vue';
import SetPopup from '@/components/SetPopup.vue';
import { mapState, mapMutations } from 'vuex';
import { materialPropertyList, materialPropertyDetail } from 'api/materialProperty/materialProperty';
import _ from 'lodash';

export default {
  data() {
    return {
      isFetching: false,
      isDataLoaded: false,
      grid: 'materialProperty',
      settings: {
        columns,
        fields,
        height: 666,
        errorMessage: '원료 특성 데이터를 검색해주세요',
        fixCol: 1,
        hideCheckBar: true,
      },
      param: {
        material: '',
        pageSize: 10000,
        currentPage: 1,
      },
      currentPage: 1,
    };
  },
  computed: {
    ...mapState('common', ['code']),
    ...mapState('member', ['userInfo']),
  },
  components: {
    RealGrid,
    SetPopup,
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations('modal', ['SET_MODAL']),
    ...mapMutations('popup', ['SET_POPUP']),

    newSample() {
      this.$emit('newSample');
    },

    loadData(v) {
      this.search(v);
    },

    async search(v) {
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        if (_.isNumber(v)) {
          this.currentPage = v;
          this.param.currentPage = v;
        }

        const res = await materialPropertyList({ ...this.param });
        const response = res.data;
        const items = response.data.items || [];
        const page = response.data.params || {};

        this.isDataLoaded = true;
        this.items = items;
        this.$refs.grid.loadData(items);
        this.$refs.grid.setPage(page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('원료 특성 목록 조회 중 오류 발생:', err);
        this.openPopup('데이터 조회에 실패했습니다.');
      } finally {
        this.isFetching = false;
      }
    },

    reset() {
      this.param = {
        material: '',
        pageSize: 10000,
        currentPage: 1,
      };
      this.currentPage = 1;
      this.search();
    },

    // 등록 탭 열기
    openAddTab() {
      this.$emit('openTab', {
        type: 'add',
        title: '원료 특성 등록',
        component: 'MaterialPropertyAdd',
        data: {},
      });
    },

    // 수정 탭 열기
    async openEditTab(data) {
      try {
        // 상세 정보 조회하여 등록일, 등록자 정보 포함해서 가져오기
        const response = await materialPropertyDetail(data.material);
        const editData = response.data.data || data;

        this.$emit('openTab', {
          type: 'edit',
          title: `원료 특성 수정 - ${editData.material}`,
          component: 'MaterialPropertyEdit',
          data: editData,
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('상세 정보 조회 실패:', error);
        this.openPopup('상세 정보 조회에 실패했습니다.');
      }
    },

    openPopup(text, closable = false, cb) {
      this.SET_POPUP({
        title: '알림',
        width: 300,
        closable: closable,
        text: text,
      });
      this.$refs.confirm.openPopup(cb);
    },

    // 탭에서 호출할 목록 새로고침 메서드
    refreshList() {
      this.search();
    },
  },
};
</script>

<style lang="scss">
.material-property {
  .v-input__slot {
    width: 100% !important;
  }
  
  .filter-list_free {
    display: flex;
    gap: 15px;
    align-items: end;
    
    li {
      width: 200px !important;
      min-width: 200px !important;
      
      h4 {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }
    }
  }
}
</style>
